"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToDate = exports.localToLuxonUtc = exports.utcDateToLocalDateTimeWithoutOffset = exports.utcDateToLocalDateWithoutOffset = exports.utcToLocalWithOffset = exports.utcToAmbiguousLocal = exports.utcToLocalForEndTime = exports.utcToLocalForStartTime = exports.utcToLaterLocal = exports.utcToEarlierLocal = exports.localToAmbiguousUtc = exports.localToLaterUtc = exports.localToEarlierUtc = void 0;
const luxon_1 = require("luxon");
const MID_YEAR_MONTH = 6;
const createDateTimeFromUTC = (fakeUtcDate, zone) => {
    return luxon_1.DateTime.fromObject({
        year: fakeUtcDate.getUTCFullYear(),
        month: fakeUtcDate.getUTCMonth() + 1,
        day: fakeUtcDate.getUTCDate(),
        hour: fakeUtcDate.getUTCHours(),
        minute: fakeUtcDate.getUTCMinutes(),
        second: fakeUtcDate.getUTCSeconds(),
        millisecond: fakeUtcDate.getUTCMilliseconds(),
    }, { zone: zone });
};
const assertPossibilities = (possibilities) => {
    const possibilitiesLength = possibilities.length;
    if (possibilitiesLength === 0 || possibilitiesLength > 2) {
        throw new Error("Invalid number of possibilities. Expected 1 or 2, found " + possibilitiesLength + ".");
    }
};
const getEarlierTime = (possibilities) => {
    const candidate0 = possibilities[0];
    const candidate1 = possibilities[1];
    assertPossibilities(possibilities);
    if (candidate1 === undefined) {
        return candidate0;
    }
    else if (candidate0.toMillis() < candidate1.toMillis()) {
        return candidate0;
    }
    else {
        return candidate1;
    }
};
const getLaterTime = (possibilities) => {
    const candidate0 = possibilities[0];
    const candidate1 = possibilities[1];
    assertPossibilities(possibilities);
    if (candidate1 === undefined) {
        return candidate0;
    }
    else if (candidate0.toMillis() > candidate1.toMillis()) {
        return candidate0;
    }
    else {
        return candidate1;
    }
};
const localToEarlierUtc = (fakeUtcDate, zone) => {
    const dt = createDateTimeFromUTC(fakeUtcDate, zone)
        .minus({ millisecond: 1 });
    const possibleOffsets = dt.getPossibleOffsets();
    return getEarlierTime(possibleOffsets).plus({ millisecond: 1 }).toJSDate();
};
exports.localToEarlierUtc = localToEarlierUtc;
const localToLaterUtc = (fakeUtcDate, zone) => {
    const dt = createDateTimeFromUTC(fakeUtcDate, zone);
    const possibleOffsets = dt.getPossibleOffsets();
    return getLaterTime(possibleOffsets).toJSDate();
};
exports.localToLaterUtc = localToLaterUtc;
const localToAmbiguousUtc = (fakeUtcDate, zone) => {
    const dt = createDateTimeFromUTC(fakeUtcDate, zone);
    return dt.toJSDate();
};
exports.localToAmbiguousUtc = localToAmbiguousUtc;
const utcToEarlierLocal = (utcDate, zone) => {
    if (utcDate.getUTCMonth() < MID_YEAR_MONTH) {
        return luxon_1.DateTime.fromJSDate(utcDate, { zone: zone })
            .minus({ millisecond: 1 })
            .setZone("etc/utc", { keepLocalTime: true })
            .plus({ millisecond: 1 })
            .toJSDate();
    }
    else {
        return luxon_1.DateTime.fromJSDate(utcDate, { zone: zone })
            .plus({ millisecond: 1 })
            .setZone("etc/utc", { keepLocalTime: true })
            .minus({ millisecond: 1 })
            .toJSDate();
    }
};
exports.utcToEarlierLocal = utcToEarlierLocal;
const utcToLaterLocal = (utcDate, zone) => {
    if (utcDate.getUTCMonth() < MID_YEAR_MONTH) {
        return luxon_1.DateTime.fromJSDate(utcDate, { zone: zone })
            .plus({ millisecond: 1 })
            .setZone("etc/utc", { keepLocalTime: true })
            .minus({ millisecond: 1 })
            .toJSDate();
    }
    else {
        return luxon_1.DateTime.fromJSDate(utcDate, { zone: zone })
            .minus({ millisecond: 1 })
            .setZone("etc/utc", { keepLocalTime: true })
            .plus({ millisecond: 1 })
            .toJSDate();
    }
};
exports.utcToLaterLocal = utcToLaterLocal;
const utcToLocalForStartTime = (utcDate, zone) => {
    return luxon_1.DateTime.fromJSDate(utcDate, { zone: zone })
        .plus({ millisecond: 1 })
        .setZone("etc/utc", { keepLocalTime: true })
        .minus({ millisecond: 1 })
        .toJSDate();
};
exports.utcToLocalForStartTime = utcToLocalForStartTime;
const utcToLocalForEndTime = (utcDate, zone) => {
    return luxon_1.DateTime.fromJSDate(utcDate, { zone: zone })
        .minus({ millisecond: 1 })
        .setZone("etc/utc", { keepLocalTime: true })
        .plus({ millisecond: 1 })
        .toJSDate();
};
exports.utcToLocalForEndTime = utcToLocalForEndTime;
const utcToAmbiguousLocal = (utcDate, zone) => {
    return luxon_1.DateTime.fromJSDate(utcDate, { zone: zone })
        .setZone("etc/utc", { keepLocalTime: true })
        .toJSDate();
};
exports.utcToAmbiguousLocal = utcToAmbiguousLocal;
const utcToLocalWithOffset = (date, zone) => {
    const localTimeWithOffset = luxon_1.DateTime.fromJSDate(date, { zone: zone }).toISO();
    if (!localTimeWithOffset) {
        throw new Error("Error converting utc date to local");
    }
    return localTimeWithOffset;
};
exports.utcToLocalWithOffset = utcToLocalWithOffset;
const utcDateToLocalDateWithoutOffset = (date, zone) => (0, exports.utcDateToLocalDateTimeWithoutOffset)(date, zone).toJSDate();
exports.utcDateToLocalDateWithoutOffset = utcDateToLocalDateWithoutOffset;
const utcDateToLocalDateTimeWithoutOffset = (date, zone) => luxon_1.DateTime.fromJSDate(date, { zone: zone }).setZone("etc/utc", { keepLocalTime: true });
exports.utcDateToLocalDateTimeWithoutOffset = utcDateToLocalDateTimeWithoutOffset;
const localToLuxonUtc = (date, zone) => luxon_1.DateTime.fromJSDate(date, { zone: "etc/utc" }).setZone(zone, { keepLocalTime: true });
exports.localToLuxonUtc = localToLuxonUtc;
const addToDate = (date, durationLike) => luxon_1.DateTime.fromJSDate(date, { zone: "etc/utc" }).plus(durationLike).toJSDate();
exports.addToDate = addToDate;
//# sourceMappingURL=date.js.map